import { useCallback } from 'react';
import { BrokerNerdsBarkerCoreEnumsMarketplace } from '../../api';
import { useSeatingChart } from './SeatingChart.hooks';
import { useGlobalState } from '../../data/Global.state';
import { MarketplaceSelectorMobile } from './SeatingChart.MarketplaceSelector.Mobile';
import { MarketplaceSelectorDesktop } from './SeatingChart.MarketplaceSelector.Desktop';
import { MarketplaceSelectorNew } from './SeatingChart.MarketplaceSelectorNew';
import { useFlag } from '@unleash/proxy-client-react';

export function MarketplaceSelector({ onChange, onClose }: { onChange: () => void; onClose?: () => void }) {
  const {
    selectedEvent,
    eventMappings,
    selectedMarketplaceId,
    setSelectedMarketplaceId,
    editMarketplaceLinksDialogHandler,
    setEventMarketplaceDefaults,
    availableMarketplaces,
    isSeasonView,
  } = useSeatingChart(
    'selectedEvent',
    'eventMappings',
    'selectedMarketplaceId',
    'setSelectedMarketplaceId',
    'editMarketplaceLinksDialogHandler',
    'setEventMarketplaceDefaults',
    'availableMarketplaces',
    'isSeasonView',
  );

  const { isMobile } = useGlobalState('isMobile');
  const useNewMarketSelector = useFlag('new-marketplace-selector');

  const onChangeMarketplace = useCallback(
    (marketplaceId: BrokerNerdsBarkerCoreEnumsMarketplace) => {
      if (selectedEvent) {
        setSelectedMarketplaceId(marketplaceId);
        setEventMarketplaceDefaults({ marketplaceId, tenantId: selectedEvent.tenantId, eventId: selectedEvent.eventId });
        onChange();

        if (onClose) {
          onClose();
        }
      }
    },
    [onChange, onClose, selectedEvent, setEventMarketplaceDefaults, setSelectedMarketplaceId],
  );

  if (isMobile) {
    return (
      <MarketplaceSelectorMobile
        onChangeMarketplace={onChangeMarketplace}
        eventMappings={eventMappings}
        selectedMarketplaceId={selectedMarketplaceId}
        editMarketplaceLinksDialogHandler={editMarketplaceLinksDialogHandler}
        availableMarketplaces={availableMarketplaces}
        isSeasonView={false}
      />
    );
  }

  if (useNewMarketSelector) {
   return (<MarketplaceSelectorNew
     onChangeMarketplace={onChangeMarketplace}
     eventMappings={eventMappings}
     selectedMarketplaceId={selectedMarketplaceId}
     editMarketplaceLinksDialogHandler={editMarketplaceLinksDialogHandler}
     availableMarketplaces={availableMarketplaces}
     isSeasonView={isSeasonView ?? false}
     onClosePopover={onClose}
   />);
  }

  return (
    <MarketplaceSelectorDesktop
      onChangeMarketplace={onChangeMarketplace}
      eventMappings={eventMappings}
      selectedMarketplaceId={selectedMarketplaceId}
      editMarketplaceLinksDialogHandler={editMarketplaceLinksDialogHandler}
      availableMarketplaces={availableMarketplaces}
      isSeasonView={isSeasonView ?? false}
      onClosePopover={onClose}
    />
  );
}
